/**
 * drawing接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const drawingEndpoints: ApiEndpoint[] = [
  {
    id: 'drawing-create',
    method: 'POST',
    path: '/api/drawings',
    name: '创建图纸',
    description: '为空间添加图纸/模型',
    category: API_CATEGORIES.DRAWING,
    bodyParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' },
      { name: 'drawingType', type: 'string', required: true, description: '图纸类型', example: 'TWO_D_PLAN|THREE_D_MODEL' },
      { name: 'fileUrl', type: 'string', required: true, description: '文件URL（URI格式）' },
      { name: 'version', type: 'string', required: true, description: '版本号（1-50字符）' },
      { name: 'scale', type: 'number', required: false, description: '比例尺（正数）' },
      { name: 'isActive', type: 'boolean', required: false, description: '是否激活', example: 'true' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '创建的图纸信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:drawing:view'
  },
  {
    id: 'drawing-space',
    method: 'GET',
    path: '/api/drawings/space/:spaceId',
    name: '获取空间图纸',
    description: '获取指定空间的图纸列表',
    category: API_CATEGORIES.DRAWING,
    pathParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '图纸列表' }
    ]
  },
  {
    id: 'drawing-active',
    method: 'GET',
    path: '/api/drawings/space/:spaceId/active',
    name: '获取空间激活图纸',
    description: '获取指定空间的激活图纸',
    category: API_CATEGORIES.DRAWING,
    pathParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '激活的图纸信息' }
    ]
  },
  {
    id: 'drawing-detail',
    method: 'GET',
    path: '/api/drawings/:id',
    name: '获取图纸详情',
    description: '获取图纸详细信息',
    category: API_CATEGORIES.DRAWING,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '图纸ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '图纸详细信息' }
    ]
  },
  {
    id: 'drawing-update',
    method: 'PUT',
    path: '/api/drawings/:id',
    name: '更新图纸',
    description: '更新图纸信息',
    category: API_CATEGORIES.DRAWING,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '图纸ID（UUID）' }
    ],
    bodyParams: [
      { name: 'drawingType', type: 'string', required: false, description: '图纸类型' },
      { name: 'fileUrl', type: 'string', required: false, description: '文件URL' },
      { name: 'version', type: 'string', required: false, description: '版本号' },
      { name: 'scale', type: 'number', required: false, description: '比例尺' },
      { name: 'isActive', type: 'boolean', required: false, description: '是否激活' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '更新后的图纸信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:drawing:view'
  },
  {
    id: 'drawing-delete',
    method: 'DELETE',
    path: '/api/drawings/:id',
    name: '删除图纸',
    description: '删除图纸',
    category: API_CATEGORIES.DRAWING,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '图纸ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:drawing:view'
  },
  {
    id: 'drawing-activate',
    method: 'PUT',
    path: '/api/drawings/:id/activate',
    name: '激活图纸',
    description: '激活指定图纸',
    category: API_CATEGORIES.DRAWING,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '图纸ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '激活后的图纸信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:drawing:view'
  },
  {
    id: 'drawing-version',
    method: 'GET',
    path: '/api/drawings/space/:spaceId/version/:version',
    name: '按版本获取图纸',
    description: '根据版本号获取图纸',
    category: API_CATEGORIES.DRAWING,
    pathParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' },
      { name: 'version', type: 'string', required: true, description: '版本号' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '该版本的图纸列表' }
    ]
  },
  {
    id: 'drawing-versions',
    method: 'GET',
    path: '/api/drawings/space/:spaceId/versions',
    name: '获取版本列表',
    description: '获取空间的图纸版本列表',
    category: API_CATEGORIES.DRAWING,
    pathParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '版本列表' }
    ]
  },
];
